import "./drop-social-links.styles.css";
import {
  FaInstagram,
  FaWhatsapp,
  FaTelegramPlane,
  FaEnvelope,
} from "react-icons/fa";

const SocialLinks = () => {
  return (
    <div className="card">
      <a
        className="socialContainer containerOne"
        href="https://www.instagram.com/youngstoring"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaInstagram className="socialSvg instagramSvg" />
      </a>
      <a
        className="socialContainer containerTwo"
        href="https://wa.me/989108794329"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp className="socialSvg whatsappSvg" />
      </a>

      <a
        className="socialContainer containerThree"
        href="https://t.me/youngstoring"
      >
        <FaTelegramPlane className="socialSvg telegramSvg" />
      </a>

      <a
        className="socialContainer containerFour"
        href="mailto:youngstoring@gmail.com"
      >
        <FaEnvelope className="socialSvg gmailSvg" />
      </a>
    </div>
  );
};

export default SocialLinks;
